import React from "react";
import { Layout, Row, Col } from "antd";

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer
      style={{
        textAlign: "center",
        background: "#000000ff",
        color: "#ffffffff",
        padding: "20px 10%", // optional spacing
      }}
    >
      {/* <Row justify="center" gutter={[20, 20]}>
        <Col>
          <a href="/about" style={{ color: "#e1e1e1" }}>About Us</a>
        </Col>
        <Col>
          <a href="/contact" style={{ color: "#e1e1e1" }}>Contact Us</a>
        </Col>
        <Col>
          <a href="/privacy" style={{ color: "#e1e1e1" }}>Privacy Policy</a>
        </Col>
        <Col>
          <a href="/terms" style={{ color: "#e1e1e1" }}>Terms & Conditions</a>
        </Col>
      </Row> */}
      <div style={{ marginTop: "10px" }}>
        © {new Date().getFullYear()} MyWebsite. All rights reserved.
      </div>
    </Footer>
  );
};

export default AppFooter;
